// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1hEfS","nav":"Header_nav__2QeJ_","logo":"Header_logo__2HVe8","login":"Header_login__eHFRM"};